import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert as RSAlert, Col, Input, Row } from "reactstrap";
import Logo from "../assets/images/logo.png";
import { DesktopContainer } from "../layouts";
import { api, storage, UserContext } from "../utils";
import { ServiceThreadSpinner } from "./";

export default function SignInQRCode(props) {
   const backToSignInPath = "/login";
   const userCtx = useContext(UserContext);
   const [authenticating, setAuthenticating] = useState(false);
   const [code, setCode] = useState(null);
   const [message, setMessage] = useState(null);
   const sleep = ms => new Promise(r => setTimeout(r, ms));

   useEffect(() => {
      inputFocus("codeInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      // if device has built-in scanner see if a scan was completed
      if (code && code.trim()) {
         setAuthenticating(true);
         setMessage(null);
         // Send the RAW scanned string; the backend classifies it (opaque B1- token or legacy QR<id>)
         // and resolves the user. No client-side parsing — a token-only badge has no commas.
         api.post("Public/AuthenticateQr", { Username: code.trim() })
            .then((response) => {
               if (api.isRateLimited(response)) {
                  // the api interceptor already toasted the server sentence
                  setAuthenticating(false);
                  return;
               }
               if (response.data.success) {
                  storage.setItem("lastUsername", response.data.user.username);
                  userCtx.signIn(response.data.user, response.data.user.token, response.data.menus);
                  if (response.data.redirectUrl) {
                     window.location = response.data.redirectUrl;
                  }
               } else {
                  setMessage({ flavor: "alert-danger", text: response?.data?.message })
               }
               // not using a finally here since the scanner browsers choke on it
               setAuthenticating(false);
            }).catch((err) => {
               console.error(err);
               setAuthenticating(false);
            }).finally(() => {
               setCode(null);
               inputFocus("codeInput");
            });
      }
      else {
         inputFocus("codeInput");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [code])

   async function inputFocus(fieldname) {
      await sleep(50);  // allows time for input to be recognized
      const el = document.querySelector(`input[name=${fieldname}]`);
      if (el !== null) {
         await el.focus();
      }
   }

   async function lookup(val) {
      // On change of QR Code input field
      setCode(val);
      inputFocus("codeInput");
   }

   return (
      <DesktopContainer fluid className="pt-5">
         <Row className="pt-5 justify-content-center position-static">
            <Col sm={12} md={6}>
               <Row className="py-3 justify-content-center">
                  <Col className="text-center">
                     <img id="Logo" src={Logo} alt="logo" />
                  </Col>
               </Row>
               <Row className="mt-3">
                  <Col xs="12">
                     <ServiceThreadSpinner on={authenticating}>
                        <div>
                           <Row className="justify-content-center">
                              <Col xs="12">
                                 <Input
                                    name="codeInput"
                                    placeholder="Scan QR Code"
                                    className="h-100"
                                    onChange={(e) => lookup(e.target.value)}
                                 />
                              </Col>
                           </Row>
                           <Row className="lineheight8">&nbsp;</Row>
                           <Row className="justify-content-center">
                              <Col xs="12">
                                 <Link
                                    to={backToSignInPath}
                                    className="float-end"
                                    children="Take me back to regular log in!"
                                 />
                              </Col>
                           </Row>
                        </div>
                     </ServiceThreadSpinner>
                  </Col>
               </Row>
               {message ? (
                  <Row className="mt-3">
                     <Col>
                        <RSAlert className={message.flavor}>{message.text}</RSAlert>
                     </Col>
                  </Row>
               ) : null}
            </Col>
         </Row >
      </DesktopContainer >
   );
}
